import { Request } from '../base/Request';
import { Method } from 'axios';

export class MediaclipUpdateProjectRequest extends Request<
  unknown,
  {
    productId: string;
    projectId: string;
    formKey: string;
  }
> {
  protected headers = {
    'Content-Type': 'multipart/form-data',
  };

  getResponse() {
    // `hyva` is injected by hyva theme in magento, this is not known to vue
    // @ts-ignore
    this.data.form_key = hyva.getFormKey();
    return super.getResponse();
  }

  protected getEndPoint(): string {
    return window.mediaclip_config.updateUrl;
  }

  protected getMethod(): Method {
    return 'POST';
  }

  public setProductId(productId: string) {
    this.data.productId = productId;
    return this;
  }

  public setProjectId(projectId: string) {
    this.data.projectId = projectId;
    return this;
  }
}
